import shop from '../../api/shop';
import * as types from '../mutation-types';

// initial state
// shape: [{ id, quantity }]
const state = {
  added: [],
  totals: {
    before_discount: 0,
    discount: 0,
    with_discount: 0,
    voucher_discount: 0,
    final: 0
  },
  cartInitialized: false
};

const initial_state = state;

// actions
const actions = {
  getCart({ commit, state }) {
    if (!state.cartInitialized) {
      state.cartInitialized = true;

      shop
        .getCart()
        .then(({ products, meta }) => {
          commit(types.INITIALIZE_CART, products);
          commit(types.UPDATE_TOTALS, meta);
        })
        .catch(() => {});
    }
  }
};

// mutations
const mutations = {
  [types.UPDATE_TOTALS](state, totals) {
    state.totals = totals;
  },

  [types.INITIALIZE_CART](state, products) {
    products.forEach(product => {
      if (!_.find(state.added, ['product_id', product.id])) {
        state.added.push({
          product_id: product.id,
          quantity: product.quantity
        });
      }
    });
  },

  [types.ADD_TO_CART](state, data) {
    const product_id = data.product_id;
    const quantity = parseInt(data.quantity, 10);
    const update = data.update || false;

    const record = state.added.find(p => p.product_id === product_id);
    if (!record) {
      state.added.push({
        product_id,
        quantity
      });
    } else {
      record.quantity = update ? quantity : record.quantity + quantity;

      if (record.quantity <= 0) {
        state.added.splice(state.added.indexOf(record), 1);
      }
    }

    shop
      .addToCart(product_id, quantity, update)
      .then(({ meta, products }) => {
        state.totals = meta;

        const product = products.find(p => p.id === product_id);
        if (product) {
          VueEventHub.$emit('product-added-to-cart', product);
        }
        VueEventHub.$emit('open-added-to-cart-modal');

        flash('Product added to cart');
      })
      .catch(() => {
        if (record) {
          record.quantity -= quantity;
        } else {
          state.added.pop();
        }
        error('Could not add product to cart.');
      });
  },

  [types.REMOVE_FROM_CART](state, product) {
    shop
      .removeFromCart(product.id)
      .then(({ meta }) => {
        const record = state.added.find(p => p.product_id === product.id);

        state.added.splice(state.added.indexOf(record), 1);

        state.totals = meta;

        VueEventHub.$emit('product-removed-from-cart', product);

        flash('Product removed from cart');
      })
      .catch(() => {
        error('Could not remove product from cart.');
      });
  },

  [types.EMPTY_CART](state) {
    shop
      .emptyCart()
      .then(() => {
        state.added = [];
        state.totals = initial_state.totals;

        flash('Cart is empty');
      })
      .catch(() => {
        error('Could not empty cart.');
      });
  }
};

export default {
  state,
  actions,
  mutations
};
